import React from 'react';
import { getGenreTagClasses } from '../../utils/genreColors';
import { abbreviateGenre } from '../../utils/genreAbbreviations';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface GenreTagProps {
  genre: string;
  subgenre?: string;
  count?: number;
  onClick?: () => void;
  className?: string;
  compact?: boolean;
}
const GenreTag: React.FC<GenreTagProps> = ({
  genre,
  subgenre,
  count,
  onClick,
  className = '',
  compact = false
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const {
    className: tagClasses,
    style
  } = getGenreTagClasses(genre, subgenre, dk.isDark, rt.badgeRadius);
  const displayText = compact ? abbreviateGenre(subgenre || genre) : subgenre || genre;
  return <div className={`${tagClasses} ${className} inline-flex items-center hover:opacity-90 ${onClick ? 'cursor-pointer' : ''}`} style={style} onClick={onClick} data-id="element-3812" data-mp="3ef42zd92gmmf">
      <span data-id="element-3813" data-mp="34ujyavm897tm">{displayText}</span>
      {count !== undefined && <span className={`ml-2 px-2 py-0.5 ${rt.badgeRadius} text-xs bg-white bg-opacity-25`} data-id="element-3814" data-mp="34s638mrjrvm2">
          {count}
        </span>}
    </div>;
};
export default GenreTag;